// opening in Grommet Layer
export const OPEN_MODAL_CARDS = 'OPEN_MODAL_CARDS';
export const CLOSE_MODAL_CARDS = 'CLOSE_MODAL_CARDS';

export const MOBILE_CARD_INDEX_NEXT = 'MOBILE_CARD_INDEX_NEXT';
export const MOBILE_CARD_INDEX_PREV = 'MOBILE_CARD_INDEX_PREV';
export const MOBILE_CARD_INDEX_RESET = 'MOBILE_CARD_INDEX_RESET';

// opening in Grommet Layer
export const OPEN_MODAL_QUESTIONS_AND_ANSWERS = 'OPEN_MODAL_QUESTIONS_AND_ANSWERS';
export const CLOSE_MODAL_QUESTIONS_AND_ANSWERS = 'CLOSE_MODAL_QUESTIONS_AND_ANSWERS';
export const OPEN_MODAL_SCHEDULES = 'OPEN_MODAL_SCHEDULES';
export const CLOSE_MODAL_SCHEDULES = 'CLOSE_MODAL_SCHEDULES';
export const OPEN_MODAL_ALBUM = 'OPEN_MODAL_ALBUM';
export const CLOSE_MODAL_ALBUM = 'CLOSE_MODAL_ALBUM';
export const OPEN_MODAL_EXPERT_TALKS = 'OPEN_MODAL_EXPERT_TALKS';
export const CLOSE_MODAL_EXPERT_TALKS = 'CLOSE_MODAL_EXPERT_TALKS';
export const OPEN_MODAL_SPONSOR = 'OPEN_MODAL_SPONSOR';
export const CLOSE_MODAL_SPONSOR = 'CLOSE_MODAL_SPONSOR';
export const UPDATE_QUIZ_RESULT = 'UPDATE_QUIZ_RESULT';

// used in mobile layout
export const SHOW_MOBILE_ALBUM_DRAWER = 'SHOW_MOBILE_ALBUM_DRAWER';
export const SHOW_MOBILE_EXPERT_TALKS_DRAWER = 'SHOW_MOBILE_EXPERT_TALKS_DRAWER';
